module.exports = __webpack_public_path__ + "illustrator-t1-8d1b18b85f8a6c406b9d.svg";